import { render, staticRenderFns } from "./TesEmployeeDetails.vue?vue&type=template&id=497c0aa9&scoped=true&"
import script from "./TesEmployeeDetails.vue?vue&type=script&lang=js&"
export * from "./TesEmployeeDetails.vue?vue&type=script&lang=js&"
import style0 from "./TesEmployeeDetails.vue?vue&type=style&index=0&id=497c0aa9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497c0aa9",
  null
  
)

export default component.exports